<template>
  <div class="my-view" @mousemove="enableSpeaking">
    <FuseaccessLogo class="fuseaccess-logo" />
    <InteractiveHead :colorMode="colorMode" class="interactive-head" />
    <h1>{{ command }}</h1>
  </div>
</template>

<script>
import FuseaccessLogo from '@/components/FuseaccessLogo.vue';
import InteractiveHead from '@/components/InteractiveHead.vue';
import { startVoiceRecognition } from '@/services/voiceRecognition';
import { speaking } from '@/services/speech';
import ChatbotService from '@/services/mlService'; // Ajusta la ruta según tu estructura

export default {
  name: "HomeView",
  components: {
    FuseaccessLogo,
    InteractiveHead,
  },
  data() {
    return {
      assistantName: "cindy", // Puedes cambiar el nombre del asistente aquí
      colorMode: "gray",
      command: "",
      conversationActive: false,
      conversationTimeout: null,
      speechEnabled: false,
      iaResponse: "",
    };
  },
  mounted() {
    ChatbotService.loadModel();
    startVoiceRecognition(this.handleVoiceCommand);
  },
  methods: {
    handlePredict(question) {
      ChatbotService.predict(question).then((response) => {
        this.conversationActive  = response.hasContext;
        this.iaResponse = response.response;
        //console.log("🤖 Respuesta IA:", this.iaResponse);
      });
    },
    handleVoiceCommand(transcript) {
      this.command = transcript.toLowerCase(); // Convertimos todo a minúsculas
    },
    resetConversationTimeout() {
      if (this.conversationTimeout) {
        clearTimeout(this.conversationTimeout);
      }
      this.conversationTimeout = setTimeout(() => {
        this.changeToGreenThenBack();
      }, 30000);
    },
    changeToGreenThenBack() {
      this.colorMode = "green";
      this.conversationActive = false;
      setTimeout(() => {
        this.colorMode = "gray";
      }, 3000);
    },
    enableSpeaking() {
      if (!this.speechEnabled) {
        speaking(`Hola, soy ${this.assistantName}, tu modelo de inteligencia artificial. Estoy aquí para ayudarte. Solo di '${this.assistantName}' seguido de tu pregunta.`);
        speaking("Di 'adiós' cuando quieras terminar la conversación.")
        this.speechEnabled = true;
      
      }
    }
    ,
    handleAssistantActivation() {
      speaking("¿En qué puedo ayudarte?");
      this.conversationActive = true;
      this.colorMode = "blue";
      this.resetConversationTimeout();
    },
    handleGoodbye() {
      speaking("Espero haberte ayudado.");
      this.changeToGreenThenBack();
      if (this.conversationTimeout) {
        clearTimeout(this.conversationTimeout);
      }
    },
  },
  watch: {

    command(newCommand) {
      if (!this.speechEnabled ){
        return
      }
      const command = newCommand.trim().toLowerCase();
      //console.log("🗣️ Comando reconocido:", command);

      // 1. Si dice "adiós", cierra la conversación
      if (command.includes("adiós")) {
        this.handleGoodbye();
        return;
      }

      // 2. Si aún no está activa la conversación y menciona el asistente
      if (!this.conversationActive && command.includes(this.assistantName)) {
        this.handleAssistantActivation();
        console.log("🟢 Activado");
        return;
      }

      // 3. Si aún no está activa y no dijo el nombre del asistente, ignora
      if (!this.conversationActive ) {
        return;
      }

      // 4. Si la conversación ya está activa, responde con la IA
      const palabras = command.trim().split(/\s+/);

      if (palabras.length > 20) {
        speaking("Intenta hacer tu pregunta más resumida");
        this.conversationActive = false;
      } else {
        this.handlePredict(command);
        this.resetConversationTimeout();
        this.conversationActive = false;
      }

            
    }
    ,
    iaResponse(newResponse) {
      speaking(String(newResponse));
    },
  },
};

</script>

<style scoped>
.fuseaccess-logo {
  transform: scale(1.5);
  position: absolute;
  left: 50%;
  top: 20%;
  transform: translate(-50%, -50%) scale(1.5);
  height: auto;
}
</style>
